import { useQuery } from "@tanstack/react-query";
import { AxiosError } from "axios";
import { sriSyncLogApi } from "./axios";
import { ValidateCurrentToken, LogoutSystem } from "../../helpers";

export type SriSyncEstado =
  | "WAITING_LOGIN"
  | "WAITING_CAPTCHA"
  | "COMPLETED"
  | "FAILED";

export type SriSyncMotivo =
  | "CAPTCHA"
  | "LOGIN"
  | "PORTAL"
  | "SUBIDA"
  | "CONFIG"
  | "TIMEOUT"
  | "OTRO";

export interface SriSyncLogI {
  jobId: string;
  clientId: number;
  client: string;
  clientDocNumber: string | null;
  tipo: string;
  ano: string | null;
  mes: string | null;
  fechaDesde: string | null;
  fechaHasta: string | null;
  estado: SriSyncEstado;
  motivo: SriSyncMotivo | null;
  error: string | null;
  encontrados: number | null;
  nuevos: number | null;
  duracionSegundos: number | null;
  date: string;
}

export interface SriSyncLogPageI {
  dato: SriSyncLogI[];
  total: number;
  page: number;
  totalPage: number;
}

export interface SriSyncLogParamsI {
  page: number;
  limit: number;
  search?: string;
  clientId?: number;
  estado?: string;
  motivo?: string;
  tipo?: string;
  dateFrom?: string;
  dateTo?: string;
}

export interface SriSyncResumenRowI {
  clientId: number;
  client: string;
  clientDocNumber: string | null;
  corridas: number;
  completadas: number;
  fallidas: number;
  conCaptcha: number;
  captchaAuto: number;
  captchaBloqueo: number;
  porcentajeBloqueo: number;
}

export interface SriSyncResumenI {
  dias: number;
  filas: SriSyncResumenRowI[];
}

const get = async <T>(url: string, params?: object): Promise<T> => {
  try {
    const token = ValidateCurrentToken();
    if (!token) throw new Error("TOKEN INVALIDO");
    const { data } = await sriSyncLogApi.get<{ data: T }>(url, {
      params,
      headers: { Authorization: token },
    });
    return data.data;
  } catch (err) {
    const res = (err as AxiosError<{ message?: string }>).response;
    if (res?.status === 401) LogoutSystem();
    throw new Error(res?.data?.message ?? (err as Error).message);
  }
};

export const useSriSyncLog = (params: SriSyncLogParamsI) =>
  useQuery(["sri-sync-log", params], () => get<SriSyncLogPageI>("", params), {
    keepPreviousData: true,
  });

export const useSriSyncResumen = (dias: number, enabled: boolean) =>
  useQuery(
    ["sri-sync-log-resumen", dias],
    () => get<SriSyncResumenI>("/resumen", { dias }),
    { enabled },
  );
